module.exports = __webpack_public_path__ + "img/slimming-1.907312fd.png";